// extracted by mini-css-extract-plugin
export default {"tooltip":"GU-z","arrow":"HU-z"};